












import { Vue, Component, Inject } from 'vue-property-decorator'

@Component
export default class Main extends Vue {
  @Inject({ from: 'isInMainWithSidebar', default: false })
  readonly isInMainWithSidebar: boolean

  get styles(): Record<string, string> {
    const styles = {
      'max-width': `${this.$vuetify.breakpoint.thresholds.md}px`,
    }
    if (this.isInMainWithSidebar) {
      styles['padding'] = '6px !important'
    }
    return styles
  }
}
